
<div class="flex-center">
    <div class="flex flex-center-h" *ngFor="let image of images" (click)="navigateTo(image.link)" [ngClass]="{'curson': !!image.link}">
        <img class="flex" [src]="image.img" />
    </div>
</div> 


